export type ActionSuccessResult<T> = {
  result: T;
};
export type ActionErrorResult<E = void> = {
  // title: string;
  message?: string;
  error?: E;
};
export function isActionError<T, E>(
  actionResult?: ActionResult<T, E>
): actionResult is ActionErrorResult<E> {
  return actionResult !== undefined && 'error' in actionResult;
}
export type ActionResult<T = void, E = void> = ActionSuccessResult<T> | ActionErrorResult<E>;
export type Result<T = void, E = void> = Promise<ActionResult<T, E>>;
